jQuery(document).ready(function onToggleReady($) {
    'use strict';

    $(document).on('click', '.opening-hours-open mark', function() {
        $('.opening-hours').addClass('visible');
        $('body').css('overflow', 'hidden');
    });
    $(document).on('click', '.opening-hours-close', function() {
        $('.opening-hours').removeClass('visible');
        $('body').css('overflow', 'auto');
    });
    $(document.body).on('click', '.opening-hours', function(e) {
        if (e.target !== this) {
            return;
        }
        $('.opening-hours').removeClass('visible');
        $('body').css('overflow', 'auto');
    });

    $(document)
        .on('click', '.cancellation-insurance__overlay__toggle', function(e) {
            e.preventDefault();
            $('.cancellation-insurance__overlay').addClass('visible');
            $('body').css('overflow', 'hidden');
        });
    $(document)
        .on(
            'click',
            '.cancellation-insurance__overlay__content__close',
            function(e) {
                e.preventDefault();
                $('.cancellation-insurance__overlay').removeClass('visible');
                $('body').css('overflow', 'auto');
            },
        );
    $(document.body)
        .on('click', '.cancellation-insurance__overlay', function(e) {
            if (e.target !== this) {
                return;
            }
            $('.cancellation-insurance__overlay').removeClass('visible');
            $('body').css('overflow', 'auto');
        });

});
